import * as TestsOM from "TestManagement/Scripts/TFS.TestManagement";
import { LinkedItemsGridViewActionsHub } from "TestManagement/Scripts/Scenarios/LinkedItemsGridView/Actions/LinkedItemsGridViewActionsHub";
import { LinkedItemsGridViewActionsCreator } from "TestManagement/Scripts/Scenarios/LinkedItemsGridView/Actions/LinkedItemsGridViewActionsCreator";
import * as LinkedItemsGridView from "TestManagement/Scripts/Scenarios/LinkedItemsGridView/ControllerViews/LinkedItemsGridView";
import { LinkedItemsGridViewSource } from "TestManagement/Scripts/Scenarios/LinkedItemsGridView/Sources/LinkedItemsGridViewSource";
import { LinkedItemsGridViewStore } from "TestManagement/Scripts/Scenarios/LinkedItemsGridView/Stores/LinkedItemsGridViewStore";

import TCMContracts = require("TFS/TestManagement/Contracts");

export class LinkedItemsGridViewOptions {
    container: JQuery;
    result: TCMContracts.TestCaseResult;
}

export class LinkedItemsGridViewHelper {
    constructor() {
        const actionsHub = new LinkedItemsGridViewActionsHub();
        const source = new LinkedItemsGridViewSource();
        this._linkedItemsGridViewStore = new LinkedItemsGridViewStore(actionsHub);
        this._linkedItemsGridViewActionsCreator = new LinkedItemsGridViewActionsCreator(actionsHub, source);
    }

    public renderLinkedItemsGrid(options: LinkedItemsGridViewOptions): void {
        let container = document.createElement("div");
        options.container.append(container);
        // Render Grid
        let props: LinkedItemsGridView.ILinkedItemsGridViewProps = {
            actionsCreator: this._linkedItemsGridViewActionsCreator,
            store: this._linkedItemsGridViewStore,
            testCaseResult: options.result
        };
        LinkedItemsGridView.renderGrid(container, props);
    }

    private _linkedItemsGridViewActionsCreator: LinkedItemsGridViewActionsCreator;
    private _linkedItemsGridViewStore: LinkedItemsGridViewStore;
}